/* eslint-disable no-param-reassign */
import moment from 'moment';
// import constants from '$$helpers/constants';
import Timeline from './timeline';
import Grid from './grid';
import Tooltip from './tooltip';

class Renderer {
  constructor() {
    this.config = null;
    this.ganttInstance = null;
    this.lastScrollY = 0;
    this.lastScrollX = 0;
    this.layers = {
      timeline: [
        {
          renderer: {
            render(item, timeline, viewport) {
              return Timeline.renderRow(item, timeline);
            },
            update: null,
            getRectangle(item, view) {
              return {
                top: Grid.getWorkloadItemTop(item.id),
                height: Grid.getWorkloadItemHeight(item.id),
                left: 0,
                right: Infinity,
              };
            },
          },
        },
      ],
      grid: [
        {
          renderer: {
            render(item, timeline, viewport) {
              return Grid.renderRow(item, timeline);
            },
            update: null,
            getRectangle(item, view) {
              return {
                top: Grid.getWorkloadItemTop(item.id),
                height: Grid.getWorkloadItemHeight(item.id),
                left: 0,
                right: Infinity,
              };
            },
          },
        },
      ],
    };
  }

  init(instance, config) {
    this.ganttInstance = instance;
    this.config = config;

    Tooltip.init(instance, config);
    Timeline.init(instance, config);
    Grid.init(instance, config);
  }

  refresh() {
    const scrollViewY = this.ganttInstance.$ui.getView('workloadVScroll');
    const scrollViewX = this.ganttInstance.$ui.getView('scrollHor');
    const gridView = this.ganttInstance.$ui.getView('workloadGrid');
    const timelineView = this.ganttInstance.$ui.getView('workloadTimeline');

    this.addFakeRowWithBackground();
  }

  beforeRender() {
    const timeline = this.ganttInstance.$ui.getView('workloadTimeline');
    const scrollViewY = this.ganttInstance.$ui.getView('workloadVScroll');
    const scrollViewX = this.ganttInstance.$ui.getView('scrollHor');

    this.lastScrollY = scrollViewY.getScrollState().position;
    this.lastScrollX = scrollViewX.getScrollState().position;

    const fakeRow = timeline.$task_data.querySelector('.gantt_resource_row.fake');

    if (fakeRow) {
      fakeRow.remove();
    }

    scrollViewY.scrollTo(null, 0);
  }

  afterRender(isNotEmptyData, needResize) {
    const scrollViewY = this.ganttInstance.$ui.getView('workloadVScroll');
    const gridView = this.ganttInstance.$ui.getView('workloadGrid');
    const timelineView = this.ganttInstance.$ui.getView('workloadTimeline');

    // scrollViewY.resize();

    if (needResize || (this.config.resourcesLayout.totalHeight > scrollViewY.getSize().height && !scrollViewY.getScrollState().scrollSize)) {
      scrollViewY.resize();
    }

    // if (_state.resourcesLayout.totalHeight <= scrollViewY.getSize().height) {
    //   this.lastScrollY = 0;
    // }

    scrollViewY.setSize(scrollViewY.getSize().width, scrollViewY.getSize().height);// adjust scroll bar size for new content
    scrollViewY.scrollTo(null, this.lastScrollY);
    gridView && gridView.scrollTo(null, this.lastScrollY);
    timelineView && timelineView.scrollTo(this.lastScrollX, this.lastScrollY);

    this.renderTodayMarker();

    if (isNotEmptyData) {
      this.addFakeRowWithBackground();
    }

    this.blockFilterPopup(false);
    this.hideSpinner();

    this.renderEmptyLayout(isNotEmptyData);
  }

  getLayers() {
    return this.layers;
  }

  onAfterScrollTimeline(e) {
    if ((e.target.scrollLeft || this.lastScrollX)) {
      setTimeout(() => {
        if (!e.target) {
          return;
        }

        this.lastScrollX = e.target.scrollLeft;
      }, 0);
    }
  }

  renderTodayMarker() {
    const timeline = this.ganttInstance.$ui.getView('workloadTimeline');
    const scale = timeline.getScale();
    let marker = timeline.$task.querySelector('.workload_marker');

    if (this.config.type === 'panel') {
      marker && marker.remove();

      return;
    }

    const now = moment().valueOf();

    const startCheck = scale.trace_x[0].valueOf();
    const endCheck = moment(scale.trace_x[scale.trace_x.length - 1]).add(1, scale.unit).valueOf();

    if (now < startCheck || now > endCheck) {
      marker && marker.remove();

      return;
    }

    const findClosestTime = arr => {
      const middleIndex = parseInt(arr.length / 2, 10);
      const rest = now < arr[middleIndex].valueOf() ? arr.slice(0, middleIndex) : arr.slice(middleIndex);

      return rest.length === 1 ? rest[0] : findClosestTime(rest);
    };

    const closestTime = findClosestTime(scale.trace_x).valueOf();
    const index = scale.trace_indexes[closestTime];
    const coefficient = (now - closestTime) / (moment(closestTime).add(1, scale.unit) - closestTime);
    const delta = scale.unit === 'day' ? -1 : parseInt(scale.width[index] * coefficient, 10);

    if (!marker) {
      marker = document.createElement('div');
      marker.className = 'workload_marker gantt_marker';
      marker.innerHTML = `<div class="gantt_marker_content">${__('gantt_today')}</div>`;

      timeline.$task.appendChild(marker);
    }

    marker.style.cssText = `left: ${scale.left[index] + delta}px;`;
  }

  addFakeRowWithBackground() {
    const timeline = this.ganttInstance.$ui.getView('workloadTimeline');
    // const fakeRow = timeline.$task_data.querySelector('.gantt_resource_row.fake');

    // if (fakeRow) {
    //   fakeRow.remove();
    // }

    const row = document.createElement('div');
    const scale = timeline.getScale();

    row.className = 'gantt_resource_row fake';

    const scrollStateX = this.ganttInstance.getScrollState().x;

    for (let i = 0; i < scale.count; i++) {
      const delta = scale.left[i] - scrollStateX;

      if (delta < -timeline.$task.offsetWidth || delta > (2 * timeline.$task.offsetWidth)) {
        // eslint-disable-next-line no-continue
        continue;
      }

      const el = document.createElement('div');

      el.className = 'gantt_resource_marker';

      el.style.cssText = `
        left: ${scale.left[i]}px;
        width: ${scale.width[i]}px;
        position: absolute`;

      el && row.appendChild(el);
    }

    timeline.$task_data.prepend(row);
  }

  showSpinner() {
    this.ganttInstance.$ui.getView('workloadTimeline').$task_data.style.opacity = 0.3;
    this.ganttInstance.$ui.getView('workloadTimeline').$task_data.style.pointerEvents = 'none';
  }

  hideSpinner() {
    this.ganttInstance.$ui.getView('workloadTimeline').$task_data.style.opacity = 1;
    this.ganttInstance.$ui.getView('workloadTimeline').$task_data.style.pointerEvents = 'all';
  }

  renderEmptyLayout(isHide) {
    const workloadNode = this.ganttInstance.$ui.getView('workload').getNode();

    if (workloadNode.querySelector('.workload_empty_layout')) {
      if (isHide) {
        workloadNode.querySelector('.workload_empty_layout').remove();
      }

      return;
    }

    if (isHide) {
      return;
    }

    if (this.config.type === 'panel') {
      this.ganttInstance.$ui.getView('workloadTimeline').$task_data.querySelector('.gantt_resource_row.fake')?.remove();

      return;
    }

    const layout = document.createElement('div');

    layout.className = 'workload_empty_layout';

    layout.innerHTML = `<div class="wrap">
        <div class="img"></div>
        <span>${__('empty_filter_logs_group_by_table')}</span>
      </div>`;
    workloadNode.append(layout);
  }

  blockFilterPopup(isBlock) {
    const popup = document.getElementById('app-filter');

    if (popup) {
      let overlay = document.querySelector('.workload_filter_overlay');

      if (!isBlock) {
        overlay && overlay.remove();

        return;
      }

      if (!overlay) {
        overlay = document.createElement('div');
        overlay.classList.add('workload_filter_overlay');
        document.body.appendChild(overlay);
      }

      overlay.style.width = `${popup.offsetWidth}px`;
      overlay.style.height = `${popup.offsetHeight}px`;
      overlay.style.top = `${popup.offsetTop}px`;
      overlay.style.left = `${popup.offsetLeft}px`;
    }
  }
}

export default new Renderer();
